import { API_URL } from "../config/api";

/**
 * Obtiene o genera un identificador único para el navegador del usuario.
 */
const getUserId = () => {
  let id = localStorage.getItem("user_id");

  if (!id) {
    id = "uid_" + crypto.randomUUID();
    localStorage.setItem("user_id", id);
  }

  return id;
};

/**
 * Obtiene las preferencias de consentimiento de cookies/tracking.
 */
const getConsent = () => {
  try {
    return JSON.parse(localStorage.getItem("tracking_consent") || "{}");
  } catch (e) {
    return {};
  }
};

/**
 * Recupera la geolocalización almacenada (latitud/longitud).
 */
const getStoredGeo = () => {
  const lat = localStorage.getItem("lat_user");
  const lon = localStorage.getItem("lon_user");

  if (lat && lon) {
    return {
      lat_user: Number(lat),
      lon_user: Number(lon)
    };
  }

  return {};
};

/**
 * Función Principal de Tracking
 * Envía eventos al endpoint de la API para su posterior inserción en BigQuery.
 * * @param {string} event - Nombre del evento (ej: 'purchase_attempt', 'page_view').
 * @param {object} data - Objeto con datos adicionales (detalle_items, detalle_cantidades, etc.).
 */
export const track = (event, data = {}) => {
  try {
    const consent = getConsent();
    const geo = (data.lat_user && data.lon_user)
      ? { lat_user: data.lat_user, lon_user: data.lon_user }
      : getStoredGeo();

    // 1. Construcción del Payload
    // Combinamos la metadata automática con los datos personalizados que vienen del carrito.
    const payload = {
      event_name: event,
      user_id: getUserId(),
      
      // Metadata de navegación y contexto
      page: window.location.href,
      referrer: document.referrer,
      user_agent: navigator.userAgent,
      timestamp_client: new Date().toISOString(),

      // Datos de Geolocalización
      lat_user: geo.lat_user || null,
      lon_user: geo.lon_user || null,

      // Inyectamos dinámicamente toda la data (aquí entran los strings con pipes '|')
      ...data
    };

    // 2. Firewall de Privacidad (Excepción Operativa)
    // Si es un intento de compra, los datos son necesarios para la gestión del pedido,
    // por lo que ignoramos el bloqueo de marketing.
    const isTransaction = event === "purchase_attempt";

    if (!consent.marketing && !isTransaction) {
      // Lista de campos que se eliminan si no hay consentimiento y no es una compra
      const sensitiveFields = [
        "nombre_cliente",
        "telefono_cliente",
        "direccion_envio",
        "email",
        "phone",
        "address",
        "name"
      ];
      
      sensitiveFields.forEach(field => {
        if (payload[field]) delete payload[field];
      });
    }

    // 3. Envío al Backend
    // Usamos 'credentials: "include"' para que viajen las cookies de sesión.
    fetch(`${API_URL}/track`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) {
        console.warn(`Tracking API responded with status: ${response.status}`);
      }
    })
    .catch((err) => {
      console.warn("Tracking fetch failed (Network error):", err);
    });

  } catch (err) {
    console.error("Critical error in tracking module:", err);
  }
};